import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Warning-circle-filled",
  "use": "icon-Warning-circle-filled-usage",
  "viewBox": "0 0 20 20",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 20\" id=\"icon-Warning-circle-filled\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M10 18.333a8.333 8.333 0 1 0 0-16.666 8.333 8.333 0 0 0 0 16.666ZM8.846 7.08a1.158 1.158 0 1 1 2.308 0l-.257 3.34a.9.9 0 0 1-1.794 0l-.257-3.34ZM10 12.083a.833.833 0 1 0 0 1.667.833.833 0 0 0 0-1.667Z\" fill=\"#FE8600\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol